




import { computed, defineComponent, ref } from '@vue/composition-api';
import SpacePage from '@/renderer/components/SpacePage/list.vue';
import { teamSpaceDrawerHandler } from '@/renderer/views/desktop/FileManagement/TeamSpace/teamSpaceDrawerHandler';
import { personalSpaceDrawerHandler } from '@/renderer/views/desktop/FileManagement/PersonalSpace/personalSpaceDrawerHandler';
import storage from '@/renderer/scripts/utils/storage';
type spaceInfo = {
  spaceId: string;
};
type TeamPathInfo = {
  path: string[];
  spaceId: string;
  id: number;
  orgId: number;
};
export default defineComponent({
  name: 'RelatedToMeFileList',
  components: {
    SpacePage,
  },
  setup(props, context) {
    const vm = context.root;
    const { params, query } = vm.$route;
    const { isCospace } = params;
    const { spaceTag } = query;
    const spaceInfo = storage.get(storage.StoreKey.RECV_SHARE_SPACE) as spaceInfo;
    const spaceId = ref<string>('');
    spaceId.value = spaceInfo?.spaceId || '';
    const teamId = -1;

    // TODO：可以优化为DynamicParams
    const defaultTeamParams = computed<Drawer.TeamSpaceDynamicParams>(() => {
      // 若是来自 团队空间 分享的文件
      let options: Drawer.TeamSpaceDynamicParams;
      const { teamId, path, teamPath, spaceId: querySpaceId } = query;
      if (querySpaceId && teamId && teamPath && path) {
        /**
         * problem:由于跨团队的分享 从与我相关跳转过来查看动态会存在权限问题
         * resolve:不看整个团队的动态 查看跳转文件的动态 需传selectedItem
         */
        options = {
          teamId: teamId as string,
          spaceId: `${querySpaceId}`,
          teamPath: teamPath as string,
          selectedItem: {
            path: (path as string).split('/'),
          },
        };
        spaceId.value = `${querySpaceId}`;
      } else {
        const teamPathInfo = storage.get<TeamPathInfo | null>(storage.StoreKey.TEAM_PATH) as TeamPathInfo;
        options = {
          teamPath: [...(teamPathInfo.path || [])].join('/'),
          spaceId: teamPathInfo.spaceId,
          teamId: `${teamPathInfo.id}`,
        };
      }
      return options;
    });
    if (spaceTag === 'team') {
      const { setDefaultDrawer } = teamSpaceDrawerHandler(defaultTeamParams, spaceId);
      setDefaultDrawer(defaultTeamParams);
    }
    // 若是来自 个人空间 分享的文件
    if (spaceTag === 'personal') {
      const { setDefaultDrawer } = personalSpaceDrawerHandler(spaceId);
      setDefaultDrawer();
    }
    return {
      spaceId,
      teamId,
      isCospace,
    };
  },
});
